import { memo } from 'react'
import { GatsbySeo } from 'gatsby-plugin-next-seo'

import { useImage } from './useImage'
import type { ImageOptions } from './useImage'

interface Props extends ImageOptions {
  preload?: boolean
}

function Image({ preload = false, className, ...otherProps }: Props) {
  const imgProps = useImage(otherProps)

  const { src, sizes = '100vw', srcSet } = imgProps

  return (
    <>
      {preload && (
        <GatsbySeo
          linkTags={[
            {
              as: 'image',
              rel: 'preload',
              href: src,
              imagesrcset: srcSet,
              imagesizes: sizes,
            } as any,
          ]}
        />
      )}
      <img
        data-store-image
        {...imgProps}
        alt={imgProps.alt}
        className={className}
        src={src}
        srcSet={srcSet}
        sizes={sizes}
      />
    </>
  )
}

Image.displayName = 'Image'
export default memo(Image)
